import { render, staticRenderFns } from "./UserConfirmOTP.vue?vue&type=template&id=bdf595fa&scoped=true"
import script from "./UserConfirmOTP.vue?vue&type=script&lang=js"
export * from "./UserConfirmOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf595fa",
  null
  
)

export default component.exports